// Conexao unica do IndexedDB local (agilzap_msgcache) compartilhada entre
// messageCache.js (historico de mensagens por ticket), mediaCache.js
// (arquivos de midia baixados) e registrationsCache.js (fichas de cadastro)
// — precisa ser um so ponto de abertura pra evitar conflito de versao entre
// os modulos.
export const DB_NAME = "agilzap_msgcache";
export const TICKETS_STORE = "tickets";
export const MEDIA_STORE = "media";
// Fila de envio offline-first (ver utils/outbox.js). Toda mensagem de texto
// nova entra aqui (status 'pending') antes de qualquer rede e só sai quando o
// servidor confirma — sobrevive a F5 / reabrir o .exe mesmo offline. keyPath =
// clientId (uuid gerado no envio; o backend deduplica por ele).
export const OUTBOX_STORE = "outbox";
// Cache local de fichas de cadastro (ver utils/registrationsCache.js).
// keyPath = id (id da ContactRegistration). Alimentado por uma sincronização
// completa em segundo plano (todas as fichas da empresa) + toda vez que a
// tela de Cadastro ou o modal de ficha buscam dados com sucesso — pra abrir
// fichas já vistas antes mesmo sem internet.
export const REGISTRATIONS_STORE = "registrations";
// v3 (13/08/2026): zera só a store de mensagens (tickets) uma única vez pra
// TODO MUNDO — corrige o bug do "cache envenenado" (ver onMessageEvent em
// layout/index.js) sem precisar pedir pra cada usuário limpar o navegador na
// mão. A store de mídia (fotos/áudio já baixados) não é tocada, continua
// intacta.
// v4 (13/08/2026): zera de novo — bug diferente (choosePreferredMessage
// preferia a versão em cache que ainda tinha o botão "Dar Baixa" em vez da
// atualizada sem botão, deixando o balão preso em "Registrando..." mesmo
// com a baixa já registrada no banco). O bug em si já foi corrigido (ver
// choosePreferredMessage), isso aqui só limpa o que já ficou errado em
// cache antes da correção.
// v5 (27/08/2026): zera mais uma vez — a gravação do cache (messageCache.js)
// era um read-modify-write não atômico e não aguardava o commit do
// IndexedDB, então dar "Dar Baixa" em vários comprovantes seguidos (ou dar
// refresh logo após clicar) perdia a atualização e o botão verde voltava no
// grupo "Extrato Ativo Pay". A gravação agora é serializada por ticket e
// espera o commit (ver enqueueTicketWrite); esse bump só descarta as
// entradas que já ficaram com o botão preso em cache antes da correção.
// v6 (02/09/2026): adiciona a store 'outbox' (fila de envio offline-first).
// Só cria a store nova — NÃO mexe em 'tickets' nem 'media' (nada é apagado).
// v7 (05/09/2026): adiciona a store 'registrations' (cache offline das fichas
// de cadastro). Só cria a store nova — nada é apagado nem alterado nas outras.
const DB_VERSION = 7;

let dbPromise = null;

export const openLocalDb = () => {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve) => {
    if (typeof window === "undefined" || !window.indexedDB) {
      resolve(null);
      return;
    }
    const req = window.indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (event) => {
      const db = req.result;
      if (event.oldVersion < 5 && db.objectStoreNames.contains(TICKETS_STORE)) {
        db.deleteObjectStore(TICKETS_STORE);
      }
      if (!db.objectStoreNames.contains(TICKETS_STORE)) {
        db.createObjectStore(TICKETS_STORE, { keyPath: "ticketId" });
      }
      if (!db.objectStoreNames.contains(MEDIA_STORE)) {
        db.createObjectStore(MEDIA_STORE, { keyPath: "url" });
      }
      if (!db.objectStoreNames.contains(OUTBOX_STORE)) {
        db.createObjectStore(OUTBOX_STORE, { keyPath: "clientId" });
      }
      if (!db.objectStoreNames.contains(REGISTRATIONS_STORE)) {
        const store = db.createObjectStore(REGISTRATIONS_STORE, { keyPath: "id" });
        store.createIndex("contactId", "contactId", { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => resolve(null);
  });
  return dbPromise;
};
